export default "__VITE_ASSET__4f0f6358__"